import { createContext, useCallback, useState, useSyncExternalStore } from "react"
import API from "services/api"
import _ from "lodash"
import toast from "react-hot-toast"

export const DashboardPatentContext = createContext({})

const DashboardPatentProvider = (props) => {
	const [byPatentypes, setBypatentypes] = useState([])
	const [todayBySub, setTodaybySub] = useState([])
	const [typesBySub, setTypebySub] = useState([])
	const [bystatus, setBystatus] = useState([])
	const [dashList, setDashList] = useState([])

	const getCountbyPatentType = (params) => {
		API.getCountbyPatentType({ params })
			.then((res) => {
				const { data } = res
				setBypatentypes(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}
	const getTodaybySubdiv = (params) => {
		API.getTodaybySubdiv({ params })
			.then((res) => {
				const { data } = res
				setTodaybySub(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getChartBarSubdiv = (params) => {
		API.getChartBarSubdiv({ params })
			.then((res) => {
				const { data } = res
				const newArray = data?.map((row) => {
					return {
						...row,
						subdiv: row?._id === "Status" ? "Registrasi" : row?._id
					}
				})
				setTypebySub(newArray)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getByStatus = (params) => {
		API.getByStatus({ params })
			.then((res) => {
				const { data } = res
				setBystatus(data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}

	const getListDashPatent = (params) => {
		API.getListDashPatent({ params })
			.then((res) => {
				const { data } = res
				setDashList(data?.data)
			})
			.catch((err) => toast.error("something wrong!", err))
	}
	return (
		<DashboardPatentContext.Provider
			value={{
				todayBySub,
				getTodaybySubdiv,

				typesBySub,
				getChartBarSubdiv,

				bystatus,
				getByStatus,

				byPatentypes,
				getCountbyPatentType,

				dashList,
				getListDashPatent
			}}
			{...props}
		/>
	)
}

export default DashboardPatentProvider
